import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = { pollUrl: String }

    connect() {
        this.poll()
    }

    disconnect() {
        if (this.timer) clearTimeout(this.timer)
    }

    async poll() {
        try {
            const response = await fetch(this.pollUrlValue, {
                headers: { "Accept": "application/json" }
            })
            const data = await response.json()

            if (data.status === "done") {
                this.element.outerHTML = data.html
            } else if (data.status === "error") {
                this.element.textContent = `Error: ${data.error}`
            } else {
                this.timer = setTimeout(() => this.poll(), 3000)
            }
        } catch {
            this.timer = setTimeout(() => this.poll(), 3000)
        }
    }
}
